<template>
  <div v-if="block.isShowed('text_contributions') || block.isShowed('contributions_list')">
    <p
      v-if="block.isShowed('text_contributions')"
      v-html="plural(block.getText('contributions'), contributionCount, variables)"
    />

    <template v-if="block.isShowed('contributions_list')">
      <template v-if="contributions.length">
        <ul class="contributions__ul margin__t--24">
          <public-contribution
            v-for="contribution in contributions"
            class="contributions__li"
            :contribution="contribution"
            :key="contribution.id"
            @update="handleUpdateContribution()"
          />
        </ul>

        <app-pagination
          class="margin__t--24"
          :paginator="pagination"
          @change="page => query.page = page"
        />
      </template>

      <div
        class="d-flex justify-content-center margin__t--12"
        v-if="!contributions.length && loader"
      >
        <app-spinner />
      </div>

      <p
        class="margin__t--24 color--lg"
        v-if="!contributions.length && !loader"
      >
        {{ translate(block.getText('no_contributions')) || t('literal.no_contributions_yet') }}
      </p>
    </template>
  </div>
</template>

<script setup>
import { reactive, computed, defineAsyncComponent, inject } from 'vue'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/ProjectStore'
import { useSampleStore } from '@/stores/SampleStore'
import { useI18n } from '@/vendors/i18n'
import { get as _get } from 'lodash'

const PublicContribution = defineAsyncComponent(() => import('&/modules/project/PublicContribution'))
const AppSpinner = defineAsyncComponent(() => import('&/atoms/AppSpinner'))
const AppPagination = defineAsyncComponent(() => import('&/molecules/AppPagination'))

defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const route = useRoute()
const { t, translate, plural } = useI18n()
const { getPublicProcedureExecutions, fetchPublicProcedureExecutions } = useProjectStore()
const { getSamples } = useSampleStore()

const objects = inject('objects', {})
const is_preview = inject('preview', false)

const id = route.params.projectSlug

const query = reactive({ id, per_page: 10, page: 1, 'sort_by_field[field]': 'created_at', 'sort_by_field[direction]': 'desc' })

const { publicProcedureExecutions, samples, loader, pagination } = is_preview.value ? getSamples({ id: 'public_procedure_executions', query: { key: 'public_procedure_executions', ...query } }) : getPublicProcedureExecutions({ id, query })

const statistics = computed(() => _get(objects.value, 'statistics', {}))
const contributionCount = computed(() => _get(statistics.value, 'contributions_count', 0))
const contributions = computed(() => is_preview.value ? samples.value : publicProcedureExecutions.value)
const variables = computed(() => ({ number_of_contributions: `<strong class="bold color--prim">${contributionCount.value}</strong>` }))

const handleUpdateContribution = () => fetchPublicProcedureExecutions({ id, query })
</script>

<style lang="scss" scoped>
.contributions {
  &__li {
    &:not(:first-child) {
      margin-top: $margin__base;
    }
  }
}
</style>